export default "<ion-app>\r\n    <ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n";